export class DkttbConstants {
  private static searchNumberRules = [
    "Tìm sim có số 9999 bạn hãy gõ 9999",
    "Tìm sim có đầu 099 đuôi 8888 hãy gõ 099*8888",
    "Tìm sim bắt đầu bằng 0993 đuôi bất kỳ, hãy gõ: 0993*",
  ];

  private static simOrEsim = [
    {
      key: "SIM_VAT_LY",
      label: "Sim vật lý",
      description: "SIM vật lý là thẻ SIM nhựa được lắp vào máy",
    },
    {
      key: "ESIM",
      label: "Sử dụng eSIM",
      description:
        "eSIM là SIM điện tử, được gửi về email của Khách hàng, thay thế cho thẻ SIM vật lý. Chỉ dùng cho các dòng máy hỗ trợ eSIM.",
    },
  ];

  private static pacakgeDuration = [
    {
      label: "Gói ngày",
      value: "Daily",
    },
    {
      label: "Gói tháng",
      value: "Monthly",
    },
    {
      label: "Gói năm",
      value: "Yearly",
    },
  ];

  private static packgeType = [
    {
      label: "Gói ngày",
      value: "Daily",
    },
    {
      label: "Gói tháng",
      value: "Monthly",
    },
    {
      label: "Gói năm",
      value: "Yearly",
    },
  ];

  static render() {
    return {
      searchNumberRules: this.searchNumberRules,
      simOrEsim: this.simOrEsim,
      pacakgeDuration: this.pacakgeDuration,
      packgeType: this.packgeType,
    };
  }
}
